import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import familyFestApi from '@infrastructure/family-fest-api';
export const fetchFamilyFestCompanyAttendeesAsync = createAsyncThunk('familyFest/fetchCompanyAttendees', async (eventId, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.getFamilyFestCompanyAttendees(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
